import { RootState } from 'handlers';

export const getGoalOptimizer = (state: RootState) => state.goalOptimizer;
